module.exports = "https://cdn.hellotech.com/client-assets/yale_locks_tablet_0a32c3c707241d61e6bfa125bc4de279.png";